import React from 'react';
import { Typography, Button, Tag } from 'antd';
import { Table, colors } from '@yuhuinc/ui-library';
import { DownloadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const BASE_LEASE_DOC_COLUMNS = [
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
    width: '35%',
  },
  {
    title: 'Start date',
    key: 'startDate',
    dataIndex: 'startDate',
    width: '20%',
  },
  {
    title: 'End date',
    key: 'endDate',
    dataIndex: 'endDate',
    width: '20%',
  },
  {
    title: 'Status',
    key: 'status',
    dataIndex: 'status',
    width: '20%',
    render() {
      return (
        <Tag color={colors.TAG_STATUS_COLORS.leaseDocument['pending_approval']}>
          Pending Approval
        </Tag>
      );
    },
  },
  {
    key: 'actions',
    width: '5%',
    render() {
      return <Button type="link" icon={<DownloadOutlined />} />;
    },
  },
];

const DUMMY_BASE_LEASE_DOCS = [
  {
    key: 1,
    name: 'Base lease',
    startDate: '2022-09-01',
    endDate: '2023-08-01',
    status: 'Pending Approval',
  },
];

const BaseLease = () => {
  return (
    <>
      <Title level={4}>Base Lease</Title>

      <Table
        dataSource={DUMMY_BASE_LEASE_DOCS}
        columns={BASE_LEASE_DOC_COLUMNS}
        hideActionAndSearch
        size={'middle'}
        pagination={{ hideOnSinglePage: true }}
      />
    </>
  );
};

export default BaseLease;
